import { useContext, useState } from 'react';

import CropImage from '../crop-image/crop-image.component';
import Spinner from '../../spinner/spinner.component';

import { ToastContext } from '../../../../contexts/toast.context';

import {
  AddImgBtn,
  AddImgInput,
  AddImgLabel,
  AddImgPreviewEmpty,
  AddImgPreview,
  ButtonGroup,
  ContentContainer,
  MainContainer,
  Text
} from '../../../../styles/component.styles';

const AddImage = ({
  image,
  setImage,
  saveImage = async () => {},
  showSaveButton = false,
  setCropData = () => {}
}) => {
  const [ loading, setLoading ] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [imagePreview, setImagePreview] = useState('');
  const [tempImage, setTempImage] = useState(null);
  const [previewBlob, setPreviewBlob] = useState(null);

  const { errorToast } = useContext(ToastContext);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return cancelImage();

    const url = URL.createObjectURL(file);
    setTempImage(file);
    setImagePreview(url);
    setPreviewBlob(null);
    setCurrentStep(1);

    if (!showSaveButton) {
      setImage(file);
    }
  };

  const submitImage = async () => {
    if(!showSaveButton || !tempImage) {
      errorToast('There was an error. Unable to save image.');
      return
    }

    setLoading(true);
    await saveImage(tempImage);
    cancelImage();
    setLoading(false);
  }

  const cancelImage = () => {
    setImage(null);
    setTempImage(null);
    setImagePreview('');
    setPreviewBlob(null);
    setCurrentStep(0);
  };

  const handleConfirmCrop = ({ crop, file, preview }) => {
    setImage(file);
    setPreviewBlob(preview);
    setCropData(crop);
    setCurrentStep(2);
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(0, prev - 1));
    setImage(null);
    setPreviewBlob(null);
  };

  const skipCropping = () => {
    if (!tempImage) return;
    setCropData(null);
    setImage(tempImage);
    submitImage();
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <AddImgPreviewEmpty><Text>No Image Selected</Text></AddImgPreviewEmpty>
            <AddImgLabel>
              Select Image
              <AddImgInput type="file" accept="image/*" onChange={handleFileChange} />
            </AddImgLabel>
          </>
        );
      case 1:
        return (
          <>
            <AddImgPreview src={imagePreview} />
            <ButtonGroup direction="row">
              <AddImgBtn onClick={cancelImage}>Cancel</AddImgBtn>
              {showSaveButton && (
                <AddImgBtn onClick={skipCropping}>Save Image</AddImgBtn>
              )}
            </ButtonGroup>
          </>
        );
      case 2:
        return (
          <>
            <AddImgPreview src={URL.createObjectURL(previewBlob || image)} />
            <ButtonGroup direction="row">
              <AddImgBtn onClick={handleBack}>Back</AddImgBtn>
              <AddImgBtn onClick={cancelImage}>Cancel</AddImgBtn>
              {showSaveButton && (
                <AddImgBtn onClick={submitImage}>Save</AddImgBtn>
              )}
            </ButtonGroup>
          </>
        );
      case 3:
        return (
          <>
            <CropImage imageFile={tempImage} onConfirm={handleConfirmCrop} />
            <ButtonGroup direction="row">
              <AddImgBtn onClick={cancelImage}>Cancel</AddImgBtn>
            </ButtonGroup>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <MainContainer>
      {loading ?
        <Spinner />
      :
        <ContentContainer>{renderStep()}</ContentContainer>
      }
    </MainContainer>
  );
};

export default AddImage;